import { Card } from "primereact/card";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Getpermissions } from "../../../store/permission-store/permission-actions";
import {
  CreateUserpermission,
  GetUserpermission,
  RemoveUserpermission,
} from "../../../store/userpermission-store/userpermission-actions";
import { ListBox } from "primereact/listbox";
import { Button } from "primereact/button";
import { getTokenInfo } from "../../../utils/Guard";
import { GetUser } from "../../../store/user-store/user-actions";
import Loading from "../../../components/UI/Loading";

const UserRoles = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user);
  const permissions = useSelector((state) => state.permission.permissions);
  const userpermissions = useSelector(
    (state) => state.userpermission.userpermissions
  );

  const notification = useSelector((state) => state.ui.notification);
  const userInfo = getTokenInfo();
  const [currentPermissions, setCurrentPermissions] = useState([]);
  const [availablePermissions, setAvailablePermissions] = useState([]);
  const [currentPermission, setCurrentPermission] = useState(null);
  const [permissionsToAssign, setPermissionsToAssign] = useState(null);
  const [waitingCurrentPermissions, setWaitingCurrentPermissions] =
    useState(true);
  const [waitingPermissionsToAssign, setWaitingPermissionsToAssign] =
    useState(true);

  const [restart, setRestart] = useState(false);

  useEffect(() => {
    if (user.id === undefined || user.id === 0) {
      dispatch(GetUser(param.userId, userInfo.Email, false));
    }
  }, [param.userId, userInfo.Email, dispatch, user]);

  useEffect(() => {
    if (
      restart === true &&
      notification !== null &&
      notification.status === "success"
    ) {
      setRestart(false);
      window.location.reload();
    }
  }, [dispatch, notification, restart]);

  useEffect(() => {
    if (permissions === undefined || permissions.length <= 0)
      dispatch(Getpermissions(userInfo.Email, false));
  }, [dispatch, permissions, userInfo.Email]);

  useEffect(() => {
    if (userpermissions === undefined || userpermissions.length <= 0) {
      dispatch(GetUserpermission(param.userId, userInfo.Email));
    }
  }, [dispatch, param.userId, userInfo.Email, userpermissions]);

  useEffect(() => {
    if (
      permissions !== undefined &&
      permissions.length > 0 &&
      userpermissions !== undefined &&
      userpermissions.length > 0
    ) {
      let pa = [];

      permissions.forEach((permissions) => {
        if (!userpermissions.some((up) => up === permissions.code)) {
          pa.push(permissions);
        }
      });

      setAvailablePermissions(pa);
    } else if (permissions !== undefined && permissions.length > 0) {
      setAvailablePermissions(permissions);
    }
  }, [dispatch, permissions, userpermissions]);

  useEffect(() => {
    if (
      permissions !== undefined &&
      permissions.length > 0 &&
      userpermissions !== undefined &&
      userpermissions.length > 0
    ) {
      let pa = [];
      permissions.forEach((permissions) => {
        if (userpermissions.some((up) => up === permissions.code)) {
          pa.push(permissions);
        }
      });
      setCurrentPermissions(pa);
    }
  }, [dispatch, permissions, userpermissions]);

  useEffect(() => {
    if (currentPermissions.length > 0 && waitingCurrentPermissions) {
      setWaitingCurrentPermissions(false);
    }
  }, [currentPermissions, waitingCurrentPermissions]);
  useEffect(() => {
    if (
      availablePermissions.length > 0 &&
      waitingPermissionsToAssign &&
      currentPermissions.length > 0 &&
      !waitingCurrentPermissions
    ) {
      setWaitingPermissionsToAssign(false);
    }
  }, [
    availablePermissions,
    currentPermissions.length,
    permissionsToAssign,
    waitingCurrentPermissions,
    waitingPermissionsToAssign,
  ]);
  useEffect(() => {
    setTimeout(() => {
      if (waitingPermissionsToAssign) {
        setWaitingPermissionsToAssign(false);
      }
      if (waitingCurrentPermissions) {
        setWaitingCurrentPermissions(false);
      }
    }, 10000);
  }, [waitingCurrentPermissions, waitingPermissionsToAssign]);

  const assignPermission = () => {
    if (permissionsToAssign !== null && permissionsToAssign.length > 0) {
      const userPermissionToAssign = {
        userId: param.userId,
        permissions: permissionsToAssign,
      };
      dispatch(CreateUserpermission(userPermissionToAssign, userInfo.Email));
      setRestart(true);
    }
  };

  const removePermission = () => {
    if (currentPermission !== null && currentPermission.length > 0) {
      const userPermissionToRemove = {
        userId: param.userId,
        permissions: currentPermission,
      };

      dispatch(RemoveUserpermission(userPermissionToRemove, userInfo.Email));
      setRestart(true);
    }
  };

  return (
    <>
      <div style={{ padding: "1%" }}>
        <Card
          style={{
            backgroundColor: "#F9FAFB",
            padding: "1%",
          }}
        >
          <div className="formgrid grid" style={{ marginTop: "-2vw" }}>
            <div className="field col-12 md:col-3" style={{ color: "" }}>
              <Button
                rounded
                text
                raised
                type="button"
                style={{
                  width: "100%",
                  backgroundColor: "#ffffff",
                }}
                icon="pi pi-arrow-left"
                severity="danger"
                label="regresar"
                onClick={() => navigate("/users/detail/" + param.userId)}
              />
            </div>
            <div className="field col-12 md:col-12" style={{ color: "" }}>
              <div style={{ marginTop: "3%" }}>
                <h1
                  className="card-header"
                  style={{
                    color: "#364151",
                    borderBottom: "double 0.5%",
                  }}
                >
                  Asignar Permisos al Usuario: {user.name + " " + user.surname1}
                </h1>
              </div>
            </div>
            <div className="field col-12 md:col-5 " style={{}}>
              <h2 style={{ color: "", marginBottom: "10%" }}>
                Permisos Actuales
              </h2>
              {waitingCurrentPermissions && <Loading color="" />}
              {!waitingCurrentPermissions && (
                <>
                  <ListBox
                  filter
                    multiple
                    value={currentPermission}
                    onChange={(e) => setCurrentPermission(e.value)}
                    options={currentPermissions}
                    optionLabel="name"
                    className="w-full md:w-14rem"
                     emptyMessage="No hay permisos disponibles"
                    listStyle={{
                      height: "480px",
                      width: "100%",
                    }}
                  />
                  <Button
                    rounded
                    text
                    raised
                    type="button"
                    style={{
                      marginTop: "3%",
                      backgroundColor: "#ffffff",
                      width: "150px",
                    }}
                    icon={
                      notification && notification.status === "pending"
                        ? "pi pi-spin pi-spinner"
                        : "pi pi-minus"
                    }
                    disabled={notification && notification.status === "pending"}
                    severity="danger"
                    label="Remover"
                    onClick={() => removePermission()}
                  />
                </>
              )}
            </div>

            <div className="field col-12 md:col-5 ">
              <h2 style={{ color: "", marginBottom: "10%" }}>
                Permisos Disponibles
              </h2>
              {waitingPermissionsToAssign && <Loading color="" />}
              {!waitingPermissionsToAssign && (
                <>
                  <ListBox
                    multiple
                    filter
                    value={permissionsToAssign}
                    onChange={(e) => {
                      setPermissionsToAssign(e.value);
                    }}
                    options={availablePermissions}
                    optionLabel="name"
                    className="w-full md:w-14rem"
                    emptyMessage="No hay permisos disponibles"
                    listStyle={{
                      height: "480px",
                      width: "100%",
                    }}
                  />
                  <Button
                    rounded
                    text
                    raised
                    type="button"
                    style={{
                      marginTop: "3%",
                      backgroundColor: "#ffffff",
                      width: "150px",
                    }}
                    icon={
                      notification && notification.status === "pending"
                        ? "pi pi-spin pi-spinner"
                        : "pi pi-plus"
                    }
                    disabled={notification && notification.status === "pending"}
                    severity="info"
                    label="Asignar"
                    onClick={() => assignPermission()}
                  />
                </>
              )}
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};
export default UserRoles;
